import SearchBarServices from './SearchBarServices'
import { ServiceData } from '../types/types'

type Props = {
  servicesData: ServiceData[]
}

function SearchInlay({servicesData}: Props) {
  return (
    <>
      <div className='text-5xl md:text-8xl font-bstSpyre mt-[191px] md-max:px-[30px] md:mt-[171px] text-center'>
        { CD_STATE?.searchTextContent?.heading ?? 'Looking for something more?' }
      </div>
      <div className='text-base-2 font-bstSpyre tracking-[0.56px] mt-XS text-center md-max:px-[30px]'>
        { CD_STATE?.searchTextContent?.subheading ?? 'Explore our services...' }
      </div>
      <SearchBarServices servicesData={servicesData} />
    </>
  )
}

export default SearchInlay